import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js/auto"

export default class extends Controller {
  static targets = ["canvas"]
  static values = { data: Object }

  connect() {
    const palette = [
      "rgba(156, 163, 175, 0.7)",
      "rgba(59, 130, 246, 0.7)",
      "rgba(16, 185, 129, 0.7)",
      "rgba(249, 115, 22, 0.7)",
      "rgba(239, 68, 68, 0.7)"
    ]

    const datasets = this.dataValue.datasets.map((ds, i) => ({
      label: ds.label,
      data: ds.data.map(d => d.views),
      counts: ds.data.map(d => d.count),
      backgroundColor: palette[i % palette.length]
    }))

    new Chart(this.canvasTarget, {
      type: "bar",
      data: { labels: this.dataValue.labels, datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: { stacked: true, title: { display: true, text: "Week" } },
          y: { stacked: true, beginAtZero: true, title: { display: true, text: "Total views" } }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: (ctx) => {
                const count = ctx.dataset.counts[ctx.dataIndex]
                return `${ctx.dataset.label}: ${ctx.parsed.y.toLocaleString()} views (${count} posts)`
              }
            }
          }
        }
      }
    })
  }
}
